import { useAtom } from 'jotai';
import { sortingStateAtom } from './state';

export const useProductSorting = () => {
    return useAtom(sortingStateAtom);
};
